export default __webpack_public_path__ + "static/social2-70e953d2337025e8fcf877eabd227409.png";